import { applePayCallBackReceived, applePayShippingAddressNotAccepted } from '@wix/bi-logger-cashier-ugc/v2';
import { OnShippingContactSelected } from '../../types/ExternalContract';
import { WidgetMeta } from '../../types/WidgetProps';
import { amountToLong } from '../../utils/amountToLong';
import { BiShippingContact, BiPpWp, BiPmApplePay } from '../../components/Hoc/BiLogger/constants';
import { BiLogger } from '../../components/Hoc/BiLogger/BiLoggerProvider';
import { ShippingError } from '../../types/Shipping';
import { getRestrictedContact, transformPaymentBreakdownToApplePay } from './applePayDataMapper';
import { createApplePayErrorConstructorParams } from './createApplePayError';

/**
 * Handles shipping contact change
 * @param session ApplePaySession
 * @param consumerCallback OnShippingContactSelected
 * @param data Object
 */
export const shippingContactSelectedHandler =
  (
    consumerCallback: OnShippingContactSelected,
    data: { paymentLabel: string; paymentAmount: string; meta: WidgetMeta; currencyCode: string },
    biLogger: BiLogger,
  ) =>
  async (event: ApplePayJS.ApplePayShippingContactSelectedEvent) => {
    try {
      let biShippingContact = '';
      try {
        biShippingContact = JSON.stringify(event.shippingContact);
      } catch (e) {}

      const response = await consumerCallback(getRestrictedContact(event.shippingContact));
      const { error, paymentAmount, paymentBreakdown, shippingMethods } = response;

      const isError = error in ShippingError;

      const newTotal = { label: data.paymentLabel, amount: isError ? data.paymentAmount : paymentAmount };
      const newLineItems = transformPaymentBreakdownToApplePay(paymentBreakdown);
      biLogger.report(
        applePayCallBackReceived({
          newValue: biShippingContact,
          amountLong: amountToLong(newTotal.amount),
          appInstanceId: data.meta.appInstanceId,
          fieldName: BiShippingContact,
          currency: data.currencyCode,
          paymentProvider: BiPpWp,
          paymentmethod: BiPmApplePay,
        }),
      );

      if (isError) {
        biLogger.report(
          applePayShippingAddressNotAccepted({
            amountLong: amountToLong(newTotal.amount),
            appInstanceId: data.meta.appInstanceId,
            currency: data.currencyCode,
            paymentMethod: BiPmApplePay,
          }),
        );
      }
      return {
        errors: isError ? [createApplePayErrorConstructorParams(error)] : undefined,
        newTotal,
        newLineItems,
        newShippingMethods: shippingMethods,
      };
    } catch (err) {
      const newTotal = { label: data.paymentLabel, amount: data.paymentAmount };
      return {
        errors: [createApplePayErrorConstructorParams(ShippingError.SHIPPING_UNKNOWN)],
        newTotal,
      };
    }
  };
